export default {
  guests: [],
  pagination: {},
  guest: {}
}
